import React from 'react'

export const alaskaSetupVars = {
  siteId: 'alaska',
  pathPrefix: '/ak',
  menuHeader: "Discover Alaska's Solution for:",
  appUrl: 'https://ak.headed2.com',
  logoImg: '/images/assets/assets/horizontal/dark.svg',
  headerTitle: `The Alaska CareerExplorer is a system designed for Alaska`
}
